module.exports = __webpack_public_path__ + "906a65586f69389d9419392c0c62a792.pdf";